


import React, { useState, useEffect } from 'react';
import Routes from '../../../routes';
import { toastResponseError } from '../../../utils';
import PropTypes from 'prop-types';
import {
    Grid,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue } from '../../../color_utils';
import Select from "../../Common/Select";
import Input from '../../Common/InputField';

import CommonModal from '../../Common/CommonModal';


const CancelWorkOrderModal = ({ payload, modalOpen, onClose, onSuccessClose, refreshRequired }) => {
    const [cancelReasons, setCancelReasons] = useState([]);
    const [cancelReasonID,setCancelReasonID] = useState(null)


    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(Routes.WorkOrder.SupportData(payload.ID, payload.LocationID, payload.ServicerID));
            const data = await response.json();
            var reasonFilter = data.workOrderStatusReason.filter((obj) => obj.workOrderStatusId == 4)
            var reasons = reasonFilter.map((obj) => { return { value: obj.id, label: obj.name } })
            setCancelReasons(reasons)
        };
        if (modalOpen == true) {
            fetchData()
        }
    }, [modalOpen])

    var saveCancelWO = async () => {

        if (cancelReasonID == null) {
            return
        }

        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: payload.ID,
                StatusReasonID: cancelReasonID,
            })
        }

        const CancelResponse = await fetch(Routes.WorkOrder.CancelWorkOrder(), postConfig)
        if (CancelResponse.status == 200) {
            onClose();
            refreshRequired();
        } else {
            // AB#17142: a forbidden or failed cancel used to fail silently
            await toastResponseError(CancelResponse, 'Failed to cancel the work order.');
        }
    }

    return (
        <CommonModal open={modalOpen} close={onClose} header={`Cancel Work Order #${payload.ID}`}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 14, fontWeight: 400 }}>
                        Only cancel Work Order if you have not opened the circuit, added refrigerant, did not shut down or installed any new systems that contain refrigerant and did not perform any leak inspections.
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Select
                        label="Cancellation Reason"
                        options={cancelReasons}
                        value={cancelReasonID}
                        onChange={(e) => setCancelReasonID(e.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={() => saveCancelWO()}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                CANCEL WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

//ReOpenModal.propTypes = {
//    id: PropTypes.string.isRequired,
//    open: PropTypes.bool.isRequired,
//    closeModal: PropTypes.func.isRequired,
//    setDataRefresh: PropTypes.func.isRequired,
//};

export default CancelWorkOrderModal;
